document.addEventListener("DOMContentLoaded", function () {
        // logout link
        var logoutBtn = document.querySelector('a[href^="/account/logout"]');

        logoutBtn.addEventListener("click", function (e) {
            e.preventDefault();

            var href =  this.getAttribute("href");
            target = '';

            fetch(window.Shopify.routes.root + 'cart/clear.js', {
                method: 'POST',
            })
            .then(response => {
                document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });

            //Wait for the data and then redirect
            setTimeout(function () { 
                window.open(href, (!target ? "_self" : target));
            }, 150);

        });
});
